'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$FetchRequest$() {
}
export { $c_Lpresto_Fetcher$FetchRequest$ as $c_Lpresto_Fetcher$FetchRequest$ };
$p = $c_Lpresto_Fetcher$FetchRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$FetchRequest$;
/** @constructor */
function $h_Lpresto_Fetcher$FetchRequest$() {
}
export { $h_Lpresto_Fetcher$FetchRequest$ as $h_Lpresto_Fetcher$FetchRequest$ };
$h_Lpresto_Fetcher$FetchRequest$.prototype = $p;
$p.aJ = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().ag($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_F1.r().C)([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$1) => {
    _$1.pE.credentials = "include";
  }))])));
});
var $d_Lpresto_Fetcher$FetchRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$FetchRequest$, "presto.Fetcher$FetchRequest$", ({
  J4: 1
}));
export { $d_Lpresto_Fetcher$FetchRequest$ as $d_Lpresto_Fetcher$FetchRequest$ };
var $n_Lpresto_Fetcher$FetchRequest$;
function $m_Lpresto_Fetcher$FetchRequest$() {
  if ((!$n_Lpresto_Fetcher$FetchRequest$)) {
    $n_Lpresto_Fetcher$FetchRequest$ = new $c_Lpresto_Fetcher$FetchRequest$();
  }
  return $n_Lpresto_Fetcher$FetchRequest$;
}
export { $m_Lpresto_Fetcher$FetchRequest$ as $m_Lpresto_Fetcher$FetchRequest$ };
//# sourceMappingURL=presto.-Fetcher$-Fetch-Request$.js.map
